import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_HistoryTimeLine = _resolveComponent("HistoryTimeLine")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mx-auto",
        elevation: "4",
        "max-width": "500"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("pppig236", -1)
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(_component_v_card_text, { class: "py-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                "hide-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "9" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode("mdi mdi-cake-variant", -1)
                          ])),
                          _: 1,
                          __: [4]
                        }),
                        _cache[5] || (_cache[5] = _createTextVNode(" Jan. 2004 ", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("mdi mdi-city", -1)
                          ])),
                          _: 1,
                          __: [6]
                        }),
                        _cache[7] || (_cache[7] = _createTextVNode(" Shanghai -> Troy -> Ann Arbor ", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("mdi mdi-heart", -1)
                          ])),
                          _: 1,
                          __: [8]
                        }),
                        _cache[9] || (_cache[9] = _createTextVNode(" Windows/Gentoo Linux/Hackintosh/Android/ZFS ", -1))
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("mdi mdi-code-braces", -1)
                          ])),
                          _: 1,
                          __: [10]
                        }),
                        _cache[11] || (_cache[11] = _createTextVNode(" C/C++/ASM/Python/Java/Kotlin ", -1))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        class: "profile",
                        color: "grey",
                        size: "60%"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_img, {
                            src: "https://avatars.githubusercontent.com/u/43439674",
                            "max-width": "200px"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog_email = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("fas fa-envelope", -1)
                    ])),
                    _: 1,
                    __: [12]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                icon: "",
                href: "https://t.me/PIPIPIG233666"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("fab fa-telegram", -1)
                    ])),
                    _: 1,
                    __: [13]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                icon: "",
                href: "https://github.com/PIPIPIG233666"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("fab fa-github", -1)
                    ])),
                    _: 1,
                    __: [14]
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                icon: "",
                href: "https://paypal.me/pig236"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("fab fa-paypal", -1)
                    ])),
                    _: 1,
                    __: [15]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mx-auto",
        elevation: "4",
        "max-width": "500",
        title: "Skills"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { lines: "two" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                prependIcon: "mdi mdi-chip",
                title: "Circuit Design",
                subtitle: "Verilog, Cadence, Overclocking"
              }),
              _createVNode(_component_v_list_item, {
                prependIcon: "mdi mdi-car",
                title: "Automotive",
                subtitle: "Mercedes-Benz diagnostics and repairing"
              }),
              _createVNode(_component_v_list_item, {
                prependIcon: "mdi mdi-linux",
                title: "Linux",
                subtitle: "C, Kernel build, Debug, System Optimization"
              }),
              _createVNode(_component_v_list_item, {
                prependIcon: "mdi mdi-android",
                title: "Android OS Development",
                subtitle: "Java, Kotlin, C++"
              }),
              _createVNode(_component_v_list_item, {
                prependIcon: "mdi mdi-web",
                title: "Webpage Development",
                subtitle: "HTML, CSS, SQLite"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mx-auto",
        elevation: "4",
        "max-width": "500",
        title: "Extracurricular activities and Achievements"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HistoryTimeLine, { items: _ctx.history }, null, 8, ["items"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dialog_email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialog_email) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { title: "Email" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" priv@pppig236.com ", -1)
                ])),
                _: 1,
                __: [16]
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, { href: "mailto:priv@pppig236.com" }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode(" Open in App ", -1)
                    ])),
                    _: 1,
                    __: [17]
                  }),
                  _createVNode(_component_v_btn, {
                    text: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog_email = false))
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode(" Close ", -1)
                    ])),
                    _: 1,
                    __: [18]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}